import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { StationRoutesDragContextWrapper } from "@ryde/controls";
import {
  IStationRouteDto,
  stationRouteDraggingStationsTempIdsAtom,
  unique,
} from "@ryde/shared";

import {
  StationRouteDragOverlay,
  StationRouteStationsPanelStyled,
  StationsPanelHeaderStationRoute,
  StationWrapperStationRoute,
} from "./parts";

interface IStationRouteStationsPanel {
  stationRouteDto: IStationRouteDto;
}

export const StationRouteStationsPanel: FC<IStationRouteStationsPanel> = ({
  stationRouteDto,
}) => {
  const dragStationIds = useRecoilValue(
    stationRouteDraggingStationsTempIdsAtom,
  );
  const sortableIds = useMemo(() => {
    const sortableIdsComputed = dragStationIds?.length
      ? dragStationIds
      : stationRouteDto.computedData?.stationInfos?.map(x => x.id) || [];
    return unique(sortableIdsComputed.filter(x => x));
  }, [dragStationIds, stationRouteDto.computedData?.stationInfos]);

  return (
    <StationRoutesDragContextWrapper>
      {Boolean(stationRouteDto) && (
        <StationRouteStationsPanelStyled>
          <StationsPanelHeaderStationRoute />
          {Boolean(sortableIds.length) && (
            <SortableContext
              items={sortableIds}
              strategy={verticalListSortingStrategy}
            >
              {sortableIds.map((stationId, stationIndex) => (
                <StationWrapperStationRoute
                  key={stationId}
                  stationId={stationId}
                  stationRouteDto={stationRouteDto}
                  isFirstStation={stationIndex === 0}
                  isLastStation={stationIndex === sortableIds.length - 1}
                  stationIndex={stationIndex}
                />
              ))}
            </SortableContext>
          )}

          <StationRouteDragOverlay />
        </StationRouteStationsPanelStyled>
      )}
    </StationRoutesDragContextWrapper>
  );
};
